import React, { useEffect, useState, useLayoutEffect, useTransition } from 'react';
import './ret.css';
import {useLocation, Link} from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const Chara=()=>{
    const [single, setsingle] = useState(window.history.state.chasi?.gaza == null ? 1 : window.history.state.chasi?.gaza);
    // const [pang, setpang] = useState();
    const [addnum, setaddnum] = useState(1);
    const coco = useLocation();
    
    // const [ing, starting] = useTransition();
 
   
    document.title = "공모전 검색 - 돌파공모";

    const fnax = async (single, bingle, signal)=>{
        const params = {sea : bingle, jun : single, signal : signal};
        const {data} = await axios.get('/api/engine',{params});  
        return data;
    };

    const {isPending, data : last, isPlaceholderData} = useQuery({queryKey:['seaz',single,coco.state.ya.sea], queryFn: ({signal})=>fnax(single, coco.state.ya.sea, signal),
     placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30});

    // useEffect(()=>{
    //     if(single == 1) return;
    //     const fetch = async()=>{
    //         const params = {sea :  coco.state.ya.sea, jun : single};
    //         const hoakin = axios.get('/api/engine',{params}).then(kip=>
    //             {starting(()=>{setpang(kip.data); }); }).catch(err=>console.log("페이지네이션 오류"));
    //     };
    //     fetch();
    // }, [single]);

    useLayoutEffect(()=>{
       
       if(window.history.state.chasi?.odir){ 
        const nopia = setTimeout(() => {
            window.scrollTo(0, window.history.state.chasi?.odir);
        }, 1); 

    return ()=>{
        clearTimeout(nopia);
    };
    }},[last]);

    const addnumber=()=>{
        setaddnum(addnum+1);
        setsingle(addnum*10+1);
        const kogaki = document.getElementById("herija");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };

    const minusnumber=()=>{
        setaddnum(addnum-1);
        setsingle((addnum-1)*10);
        const kogaki = document.getElementById("herija");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };

    const lesson = (cons)=>{
        setsingle(cons);
        window.history.replaceState({...window.history.state, chasi : {gaza: single, odir : 0}}, null,null);
        const kogaki = document.getElementById("herija");
        kogaki.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

return(
<>
<div id="herija" style={{minHeight : '20px'}}></div>
{isMobile ? <div className='mayod'>
    {single == 1 ? coco.state.yo.a.map(ele => {return <div className='myod'>
        <div className='myod1'><img src={process.env.PUBLIC_URL+'/upost/'+ele.poster}/></div>
        <div className='myod2'>
            <p><Link to={`/ajo/${ele.id}`} state={ele} className='yod4' onClick={()=>{
                         window.history.pushState({...window.history.state, chasi : {gaza : single, odir : window.scrollY}},null,null);}}>{ele.title}</Link></p>
            <p>{dayjs(ele.start).format('YY-MM-DD')} ~ {dayjs(ele.end).format('YY-MM-DD')}</p>
            <p>{ele.holder}</p>
        </div>
        </div>}) : last?.a?.map(ele => {return <div className='myod'>
        <div className='myod1'><img src={process.env.PUBLIC_URL+'/upost/'+ele.poster}/></div>
        <div className='myod2'>
            <p><Link to={`/ajo/${ele.id}`} state={ele} className='yod4' onClick={()=>{
                         window.history.pushState({...window.history.state, chasi : {gaza : single, odir : window.scrollY}},null,null);}}>{ele.title}</Link></p>
            <p>{dayjs(ele.start).format('YY-MM-DD')} ~ {dayjs(ele.end).format('YY-MM-DD')}</p>
            <p>{ele.holder}</p>
        </div>
        </div>})}
    {coco.state.yo.b == 0 && <div className='nore'>검색 결과가 없습니다</div>}    
</div> :
<div>
    {single == 1 ? coco.state.yo.a.map(ele => {return <div className='yod'>
        <div className='yod1'><img src={process.env.PUBLIC_URL+'/upost/'+ele.poster}/></div>
        <div className='yod2'>
            <p><Link to={`/ajo/${ele.id}`} state={ele} className='yod4' onClick={()=>{
                         window.history.pushState({...window.history.state, chasi : {gaza : single, odir : window.scrollY}},null,null);}}>{ele.title}</Link></p>
            <p>{dayjs(ele.start).format('YY-MM-DD')} ~ {dayjs(ele.end).format('YY-MM-DD')}</p>
            <p>{ele.holder}</p>
        </div>
        </div>}) : last?.a?.map(ele => {return <div className='yod'>
        <div className='yod1'><img src={process.env.PUBLIC_URL+'/upost/'+ele.poster}/></div>
        <div className='yod2'>
            <p><Link to={`/ajo/${ele.id}`} state={ele} className='yod4' onClick={()=>{
                         window.history.pushState({...window.history.state, chasi : {gaza: single, odir : window.scrollY}}, null,null);}}>{ele.title}</Link></p>
            <p>{dayjs(ele.start).format('YY-MM-DD')} ~ {dayjs(ele.end).format('YY-MM-DD')}</p>
            <p>{ele.holder}</p>
        </div>
        </div>})}
    {coco.state.yo.b == 0 && <div className='nore'>검색 결과가 없습니다
        </div>}
</div>
}
<div>
{addnum >1 && <button onClick={minusnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssleft.png'} className='yulll'/></button>}
    {coco.state.yo.b /100 >= addnum ? Array.from({length : 10},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
    return(<button onClick={()=>lesson(cons)} className="aisu">{cons}</button> );}) : Array.from({length : Math.ceil((coco.state.yo.b%100)/10)},(_,i)=>(addnum-1)*10+i+1).map((cons,i)=>{
 
    return(<button onClick={()=>lesson(cons)} className={`aisu ${single == cons ? "yahii" : ""}`}>{cons}</button> );})}
    {coco.state.yo.b > addnum*100 && <button onClick={addnumber} className='yoruni'><img src={process.env.PUBLIC_URL+'/ssright.png'} className='yurrr'/></button>}
</div>

</>
);
}

export default Chara;